import React from "react";

function Pizza() {
  return (
    <div>
      <div class="wrapper" id="menu">
        <div class="title">
          <h4 style={{ textAlign: "center" }}>
            <span>voici nos pizza N'hésitez pas appelez le 09 50 85 13 53</span>
            1- Pizza à base sauce tomate{" "}
          </h4>
        </div>
        <div class="menu">
          <div class="single-menu">
            <img
              src="https://www.dominos.fr/ManagedAssets/FR/product/P4FR/FR_P4FR_fr_hero_8003.jpg?v-1416700018"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza 4 Fromages<span>6€ </span>
              </h4>
              <p>Mozza,chévre, raclette, brie</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://fnfhouse.fr/67-large_default/pizza-pecheur.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Pecheur <span>6€</span>
              </h4>
              <p>
                {" "}
                Fromage,thon,olives, origan, oeuf
                <br />
              </p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://www.recette360.com/wp-content/uploads/2018/08/Pizza-v%C3%A9g%C3%A9tarienne-aux-l%C3%A9gumes-avec-thermomix.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Végétarienne<span>6€</span>
              </h4>
              <p>Fromage,oignons, champignons, poivrons</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlaLZKIG5B_ENqIM_Sf2GNattYbWwbDhNHWPQdaIY8nkavBaUdR_UuwP1rK2Yer5Br28g&usqp=CAU"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Kebab<span>6€</span>
              </h4>
              <p>Fromage,kebab, origan</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://www.commerces-de-france.fr/wp-content/uploads/2020/04/pizza_orientale2.png"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Orientale <span>6€</span>
              </h4>
              <p>Fromage,merguez, origan, oeuf</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://m1.quebecormedia.com/emp/cdp_prod/coup_de_pouce-_-119a3128-5120-4826-8efb-ad07d93ed4fc-_-pizza-poulet-legugrilles410.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Chicken<span>6€</span>
              </h4>
              <p>Fromage,poulet, oignons, origan</p>
            </div>
          </div>
        </div>
        <div class="title">
          <h4 style={{ textAlign: "center" }}>2- Pizza à base créme fraiche</h4>
        </div>
        <div class="menu">
          <div class="single-menu">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQspUxO3-pjm2EvFD8F4EH5Cj-xT2mZaTik9KH1wJ7VOHPV1WPUwpil4AeJzySQQLuPGlc&usqp=CAU"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza chèvre miel <span>6€</span>
              </h4>
              <p>Fromage,Chèvre miel</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOgrklnmrKRa1zrJJAOfRd0cTHLo7v_QKT8_1-bDtr-MVY_kw9xz-S_Fr60j-EQz0Uu-E&usqp=CAU"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Pacifique <span>6€</span>
              </h4>
              <p> Fromage,Saumon fumé, pomme de terre</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://lesucresale-doumsouhaib.com/wp-content/uploads/2016/05/pizza-cr%C3%A8me-fraiche-reblochon.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Paysane<span>6€</span>
              </h4>
              <p>Fromage,poulet fumé,pomme de terre,boursin</p>
            </div>
          </div>
          <div class="single-menu">
            <img
              src="https://static.blog4ever.com/2015/06/803540/big_artfichier_803540_5005452_201507204657390.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Boursin<span>6€</span>
              </h4>
              <p>Fromage,jambon, pomme de terre, oignon</p>
            </div>
          </div>

          <div class="single-menu">
            <img
              src="https://media-cdn.tripadvisor.com/media/photo-s/0f/77/c8/e4/pizza-victoria-creme.jpg"
              alt=""
            />
            <div class="menu-content">
              <h4>
                Pizza Chicken<span>6€</span>
              </h4>
              <p>Fromage,poulet mariné,pomme de terre,oignon</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pizza;
